import { render } from "./BranchReport.vue?vue&type=template&id=23a1905e&scoped=true"
import script from "./BranchReport.vue?vue&type=script&lang=js"
export * from "./BranchReport.vue?vue&type=script&lang=js"

import "./BranchReport.vue?vue&type=style&index=0&id=23a1905e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a1905e"]])

export default __exports__